
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "74px",
    "height": "74px",
    "viewBox": "0 0 74 74",
    "enable-background": "new 0 0 74 74",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "74",
        "height": "74"
      }
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "#FFFFFF",
                "d": "M220.824,313.062c1.51,0,2.734,1.224,2.734,2.733v4.375c0,1.509-1.225,2.733-2.734,2.733h-25.153\n\t\t\tc-1.51,0-2.733-1.225-2.733-2.733v-4.375c0-1.51,1.224-2.733,2.733-2.733h5.938c0.656,0,1.248,0.401,1.486,1.014\n\t\t\tc0.47,1.2,1.255,2.266,2.2,2.266h5.903c0.945,0,1.73-1.065,2.201-2.266c0.238-0.612,0.829-1.014,1.486-1.014H220.824z\n\t\t\t M196.343,311.967l3.672-9.155c0.153-0.384,0.308-0.688,0.837-0.688h3.022v-2.188h-3.344c-1.045,0-1.999,0.674-2.468,1.739\n\t\t\tl-4.956,11.298c0.68-0.619,1.575-1.007,2.564-1.007H196.343z M215.643,302.124c0.53,0,0.686,0.304,0.838,0.688l3.673,9.155h0.671\n\t\t\tc0.99,0,1.885,0.388,2.565,1.007l-4.958-11.298c-0.467-1.065-1.421-1.739-2.467-1.739h-3.343v2.188H215.643z M213.424,304.312\n\t\t\th-1.895v-6.563c0-1.208-0.98-2.187-2.188-2.187h-2.187c-1.208,0-2.188,0.979-2.188,2.187v6.563h-1.895\n\t\t\tc-1.121,0-1.777,1.117-1.137,1.924l4.887,6.17c0.691,0.872,2.158,0.874,2.851,0l4.886-6.17\n\t\t\tC215.201,305.429,214.545,304.312,213.424,304.312z"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "fill": "none",
            "d": "M73,65c0,4.4-3.6,8-8,8H9c-4.4,0-8-3.6-8-8V9c0-4.4,3.6-8,8-8h56c4.4,0,8,3.6,8,8V65z"
          }
        }
      ]
    },
    {
      "tag": "g",
      "children": [
        {
          "tag": "g",
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "fill": "currentColor",
                "d": "M51.318,53.324H23.32v-5.863c0-0.908,0.736-1.646,1.646-1.646c3.639,0,9.883-2.949,9.883-6.588\n\t\t\tc0,0,0-0.45,0-1.26c0-1.644-0.107-2.017-2.289-4.198c-1.621-1.359-2.652-3.4-2.652-5.684c0-4.092,3.316-7.41,7.412-7.41\n\t\t\tc4.092,0,7.41,3.318,7.41,7.41c0,2.282-1.031,4.323-2.65,5.683c-2.17,2.169-2.281,2.533-2.281,3.967\n\t\t\tc0,0.754-0.01,1.492-0.01,1.492c0,3.639,6.244,6.588,9.882,6.588c0.91,0,1.647,0.737,1.647,1.646V53.324z"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  